import React, { useContext } from 'react';
import { CaretRight } from '@wix/wix-ui-icons-common/system';
import Button from '../../../Button';
import TextButton from '../../../TextButton';
import { BUTTON_TYPES, DATA_HOOKS, SKINS } from '../../constants';
import { useIcons } from '../../../WixDesignSystemIconThemeProvider';
import { WixDesignSystemContext } from '../../../WixDesignSystemProvider/context';

import { classes } from '../AccordionItem/AccordionItem.classes';
import { AccordionItemCaretProps } from '../../Accordion.types';

const AccordionItemCaret = ({
  showLabel,
  buttonType,
  skin,
  open,
  disabled,
  hover,
  isLabelShown,
  collapseLabel,
  expandLabel,
}: AccordionItemCaretProps) => {
  const icons = useIcons('AccordionItemCaret', {
    CaretRight,
  });

  const { mobile } = useContext(WixDesignSystemContext);

  const skinProp = skin === SKINS.neutral ? 'dark' : 'standard';
  const label = open ? collapseLabel : expandLabel;

  if (buttonType === BUTTON_TYPES.node && isLabelShown && label) {
    return <div data-hook={DATA_HOOKS.toggleButton}>{label}</div>;
  }

  if (
    buttonType === BUTTON_TYPES.button &&
    label &&
    // For this buttonType, showLabel default is 'always' if undefined.
    (showLabel === 'hover' ? hover || mobile : true)
  ) {
    return (
      <Button
        skin={skinProp}
        size="tiny"
        priority={open ? 'secondary' : 'primary'}
        disabled={disabled}
        dataHook={DATA_HOOKS.toggleButton}
        children={label}
      />
    );
  }

  if (buttonType === BUTTON_TYPES.textButton) {
    const withLabel = !!(isLabelShown && label);

    return (
      <TextButton
        className={classes.caretButton()}
        skin={skinProp}
        size="tiny"
        suffixIcon={<icons.CaretRight className={classes.caret()} />}
        disabled={disabled}
        dataHook={DATA_HOOKS.toggleButton}
        children={withLabel && label}
      />
    );
  }

  return null;
};

export default AccordionItemCaret;
